import AllNotes from './all_notes.ui';
import Loader from './loader.jsx';
import fetchTree, { group, depends, virtual } from 'fetch-tree';

import R from 'ramda';
import { createSelector } from 'reselect';
import { contentLoader } from '../resources/content';
import { notesByContentLoader } from '../resources/markup';
import { analyticsEvent } from '../actions/analytics';
import {
    selectUser,
    isInstructorInSection,
    hideSharingQA,
} from '../selectors/current_user';
import {
    selectUnansweredFromNotes,
    selectPagesFromNotes,
} from '../selectors/markup';
import { selectChapters } from '../selectors/content';
import {
    toggleControlPanelVisibility,
    closeControlPanel,
} from '../actions/notes_control_panel';
import { routeToAllNotes, routeToContentPage } from '../actions/route';
import { sectionLoader } from '../resources/section';
import { setOrigin } from 'actions/content';
import { addAural } from 'actions/aural_notification';

const extractTagsFromNotes = createSelector(
    allNotes => allNotes,
    allNotes => {
        const tmp = R.compose(
            R.reduce(R.union, []),
            R.map(R.prop('tags'))
        );
        return tmp(allNotes);
    }
);

const extractClassmatesFromNotes = R.memoize(
    R.reduce((classmates, note) => {
        classmates[note.author] = note.author_name;
        return classmates;
    }, {})
);

const selectControlPanelOpen = state => state.notes_control_panel.is_open;

export const resources = group({
    contentId: depends([depends.prop('params.contentId')], (state, id) =>
        Number(id)
    ),
    query: depends([depends.prop('location.query')], (state, query) => query),
    user: virtual(selectUser),
    current_user_uri: depends(['user.v3_uri'], (state, uri) => uri),
    controlPanelIsOpen: selectControlPanelOpen,

    content: depends(['contentId'], contentLoader),
    section: depends(['content.section_id'], sectionLoader),
    isInstructor: depends(['section'], isInstructorInSection),
    allNotes: depends(['content'], notesByContentLoader),
    allClassmates: depends(['allNotes'], (state, allNotes) =>
        extractClassmatesFromNotes(allNotes)
    ),
    unansweredList: depends(['allNotes'], selectUnansweredFromNotes),
    allTags: depends(['allNotes'], (state, allNotes) =>
        extractTagsFromNotes(allNotes)
    ),
    allInstructors: depends(
        ['section.instructors'],
        (state, instructors) => instructors
    ),
    allChapters: depends(['content'], selectChapters),
    allPages: depends(['allNotes'], selectPagesFromNotes),
    hideSharingQA,
    origin: depends(
        ['content'],
        ({
            content: {
                content: { origin },
            },
        }) => origin
    ),
});

export default fetchTree({
    busy: Loader,
    component: AllNotes,
    mapDispatchToProps: {
        addAural,
        closeControlPanel,
        toggleControlPanelVisibility,
        routeToContentPage,
        routeToAllNotes,
        analyticsEvent,
        setOrigin,
    },
    resources,
});



// WEBPACK FOOTER //
// ./src/components/all_notes.jsx